import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Animated, Pressable, StyleSheet, View } from "react-native";

const FADE_DURATION = 300;

const classes = StyleSheet.create({
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
});

export default function RawCustomModal(props) {
  const { visible, onClose, style, children, zIndex = 1000 } = props;

  const opacity = useRef(new Animated.Value(0)).current;
  const [shouldRender, setShouldRender] = useState(visible);

  useEffect(() => {
    if (visible) {
      setShouldRender(true);
      Animated.timing(opacity, {
        toValue: 1,
        duration: FADE_DURATION,
        useNativeDriver: false,
      }).start();
    } else {
      Animated.timing(opacity, {
        toValue: 0,
        duration: FADE_DURATION,
        useNativeDriver: false,
      }).start(() => setShouldRender(false));
    }
  }, [opacity, visible]);

  if (!shouldRender) {
    return null;
  }

  const modalContent = (
    <Animated.View style={[classes.overlay, { opacity, zIndex }]}>
      <Pressable style={StyleSheet.absoluteFill} onPress={onClose} />
      <View style={style}>{children}</View>
    </Animated.View>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}
